import { ButtonProps } from "@chakra-ui/react";
import React from "react";
import { IoLink } from "react-icons/io5";

import { Button, useToast } from "../../../components";
import { copy } from "../../../utils/clipboard";
import { SendGAEvent, useSendGAEvent } from "../../../utils/googleAnalytics";

type CopyLinkButtonProps = ButtonProps & {
  href: string;
  gaEventDetails?: Parameters<SendGAEvent>;
  toastText?: string;
};

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({
  onClick,
  href,
  gaEventDetails,
  toastText = "Link copied to clipboard",
  ...buttonProps
}) => {
  const toast = useToast();
  const sendGAEvent = useSendGAEvent();

  if (!href) return null;

  return (
    <Button
      variant="ghost"
      py="2.5"
      px="3"
      fontWeight="medium"
      fontSize="sm"
      leftIcon={<IoLink size={20} />}
      ml="auto"
      mr="6"
      {...buttonProps}
      onClick={(e) => {
        copy(href);
        if (gaEventDetails) {
          sendGAEvent(...gaEventDetails);
        }
        toast({
          title: toastText,
          status: "success",
        });
        onClick?.(e);
      }}
    >
      Copy link
    </Button>
  );
};

export default CopyLinkButton;
